import footer_bg from './images/footer-bg.svg';
import footer_mobile_bg from './images/footer-mobile-white-bg.svg';
import footer_blue_bg from './images/footer-blue-bg.png';
import footer_blue_mobile_bg from './images/footer-blue-mobile-bg.svg';
import { StaticImageData } from 'next/image';
import { LinkHref } from '../navbar/config';
const footerList = [
  {
    title: '腾讯SSV',
    list: [
      // { text: '开放平台', path: '' },
      { text: '案例库', path: LinkHref.Case },
      { text: '报告', path: LinkHref.Report },
      // { text: '关于SSV', path: LinkHref.AboutSSV },
    ],
  },
  {
    title: '更多科技向善',
    list: [
      { text: '腾讯公益', path: 'https://gongyi.qq.com/' },
      { text: '腾讯基金会', path: 'https://www.tencentfoundation.org/' },
    ],
  },
  {
    title: '了解公司',
    list: [
      {
        text: '关于腾讯',
        path: 'https://www.tencent.com/zh-cn/about.html#about-con-1',
      },
      { text: '加入我们', path: 'https://careers.tencent.com/' },
    ],
  },
  {
    title: '法律信息',
    list: [
      {
        text: '服务协议',
        path: 'https://www.tencent.com/zh-cn/service-agreement.html',
      },
      {
        text: '隐私政策',
        path: 'https://www.tencent.com/zh-cn/privacy-policy.html',
      },
      { text: '知识产权', path: 'https://ipr.tencent.com/' },
    ],
  },
];
export default footerList;

export type Theme = 'white' | 'blue';
const bgConfig = {
  white: {
    mobile: footer_mobile_bg,
    pc: footer_bg,
  },
  blue: {
    mobile: footer_blue_mobile_bg,
    pc: footer_blue_bg,
  },
};
const colorConfig = {
  white: {
    text: '#353f49',
  },
  blue: {
    text: '#ffffff',
  },
};

export const getBg = (isMobile: boolean, theme: Theme) => {
  const bg = isMobile ? bgConfig[theme].mobile : bgConfig[theme].pc;
  return bg as unknown as StaticImageData;
};
export const getColor = (theme: Theme) => {
  const color = colorConfig[theme].text;
  return color;
};
